import { Input } from "@/components/ui/input.jsx";
import { Slider } from "@/components/ui/slider.jsx";
import { Button } from "@/components/ui/button.jsx";
import { useEffect, useRef, useState } from "react";
import { router } from "@inertiajs/react";

const ranges = [
  [0, 1000],
  [1000, 2000],
  [2000, 3000],
  [4000, 5000],
  [5000, 6000],
  [6000, 20000],
];

export default function ({ onValuesChange }) {
  if (import.meta.env.SSR) return null;

  const params = new URLSearchParams(document.location.search);
  const [[min, max], setPrice] = useState(() => {
    const price = params.get("filter[price]");
    return price ? price.split(",") : [0, 10000];
  });
  const minPriceRef = useRef(null);
  const maxPriceRef = useRef(null);

  const handleApplyPriceFilterButtonClick = () => {
    onValuesChange([min, max]);
    // params.set(`filter[price]`, `${min},${max}`)
    // router.visit(`?${params.toString()}`, {except: ['filters']})
  };

  const handleReset = () => {
    params.delete("filter[price]");
    router.visit(`?${params.toString()}`, { except: ["filters"] });
  };

  useEffect(() => {}, [min, max]);

  const handlePriceChange = (value) => {
    const [min, max] = value;
    // minPriceRef.current.value = min;
    // maxPriceRef.current.value = max;
    setPrice(value);
  };
  return (
    <div>
      <ul className="py-4 space-y-2 hidden">
        {ranges.map(([min, max], index) => (
          <li className=" text-gray-600" onClick={() => setPrice([min, max])}>
            <button>
              {min} - {max}
            </button>
          </li>
        ))}
      </ul>
      <div className="grid gap-4">
        <div className="grid grid-cols-2 gap-4">
          <Input
            placeholder={min}
            value={min}
            ref={minPriceRef}
            onChange={(e) => setPrice([e.target.value, max])}
          />
          <Input
            placeholder={max}
            value={max}
            ref={maxPriceRef}
            onChange={(e) => setPrice([min, e.target.value])}
          />
        </div>
        <Slider
          defaultValue={[0, max]}
          value={[min, max]}
          max={10000}
          step={250}
          onValueChange={handlePriceChange}
        />
        <div className="flex justify-between items-center">
          <Button variant="link" onClick={handleReset}>
            Сбросить
          </Button>
          <Button color="pink" onClick={handleApplyPriceFilterButtonClick}>
            Применить
          </Button>
        </div>
      </div>
    </div>
  );
}
